import { useState } from 'react';
import type { Character } from '@/types/content';

interface CharacterSectionProps {
  characters: Character[];
}

export default function CharacterSection({ characters }: CharacterSectionProps) {
  const [expanded, setExpanded] = useState(false);
  const collapsible = characters.length > 2;
  const visible = expanded || !collapsible ? characters : characters.slice(0, 2);

  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <i className="ri-group-line text-lg text-primary-500" />
          <h2 className="font-heading text-lg font-bold text-foreground-950">角色介绍</h2>
        </div>
        {collapsible && (
          <button
            type="button"
            onClick={() => setExpanded((prev) => !prev)}
            className="flex items-center gap-1 whitespace-nowrap text-sm font-label text-primary-500 transition-colors hover:text-primary-700"
          >
            {expanded ? '收起' : '展开全部'}
            <i className={expanded ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} />
          </button>
        )}
      </div>

      <div className="mt-4 space-y-3">
        {visible.map((character) => (
          <div
            key={character.name}
            className="flex items-start gap-4 rounded-lg bg-background-100 p-4"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-base font-bold text-background-50">
              {character.name.slice(0, 1)}
            </span>
            <div className="min-w-0">
              <div className="flex flex-wrap items-center gap-2">
                <h3 className="font-heading text-base font-bold text-foreground-950">{character.name}</h3>
                <span className="rounded-full bg-accent-100 px-2 py-0.5 text-xs text-accent-900">
                  饰演 · {character.actor}
                </span>
              </div>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{character.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}